import type { GetMinMaxAndAllowablesResult } from 'src/app/v1/views/components/Pay/util/getMinMaxAndAllowables';
import type { ValidationTranslations } from 'src/app/v1/views/components/Pay/util/getValidationTranslations';

import type { SalaryError } from './types';

export const getErrorForMinValidationType = (
  {
    tPayRangeValidationMinReq,
    tValMinGreaterThanMinAllowable,
    tValMinLessThanMaxAllowable,
  }: ValidationTranslations,
  {
    minimum,
    minimumText,
    minAllowableSalary,
    maxAllowableSalary,
  }: Pick<
    GetMinMaxAndAllowablesResult,
    'minimum' | 'minAllowableSalary' | 'minimumText' | 'maxAllowableSalary'
  >,
): SalaryError => {
  if (!minimumText || minimumText.trim().length === 0 || isNaN(minimum)) {
    return { min: tPayRangeValidationMinReq };
  }
  if (minimum < minAllowableSalary) {
    return { min: tValMinGreaterThanMinAllowable };
  }
  if (minimum > maxAllowableSalary) {
    return {
      min: tValMinLessThanMaxAllowable,
    };
  }
  // setSalaryErrorMin(error.min);
  return { min: null };
};
